import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Balance } from 'organisms';
import { getCurrentBalance, getCurrentBonus  } from 'app/shared/store/slices/currentUserSlice';
import { formatCurrency } from 'foundation/Helpers';

import PropTypes from 'prop-types';

const UserAccountBalanceApp = (props) => {
  const dispatch = useDispatch();

  const user = useSelector(state => state.currentUser.currentUser);
  const [bonusContent, setBonusContent] = useState(null);

  useEffect(() => {
    if(user.isAuthenticated) {
      dispatch(getCurrentBalance());
      dispatch(getCurrentBonus());
    }
  }, []);

  useEffect(() => {
    if (user.bonus) {
      setBonusContent({
        usageValue: user.bonus.current.Amount,
        usageText: formatCurrency(user.bonus.current.Amount, true),
        maxValue: user.bonus.target.Amount,
        maxText: formatCurrency(user.bonus.target.Amount, true),
        text: props.bonusMessage,
        textData: [{ key: 'BONUS', value: formatCurrency(user.bonus.target.Amount, true) }]
      });
    }
  }, [user.bonus]);

  if (!user) {
    return null;
  }

  return (
    <>
      { props.showBalance && user.isAuthenticated && <Balance balance={user?.balance?.formattedCalculatedBalance} bonus={bonusContent}/> }
    </>
  );
};

UserAccountBalanceApp.propTypes = {
  bonusMessage: PropTypes.string,
  showBalance: PropTypes.bool
};

UserAccountBalanceApp.defaultProps = {
  bonusMessage: '',
  showBalance: true
};

export default UserAccountBalanceApp;